const OFFICIAL_USERNAMES = new Set(['solarix']);

export const isOfficialUsername = (username) => {
  if (!username) return false;
  return OFFICIAL_USERNAMES.has(String(username).toLowerCase());
};

const OfficialBadge = ({ username, className = '' }) => {
  if (!isOfficialUsername(username)) return null;

  return (
    <span
      title="официальный аккаунт"
      aria-label="официальный аккаунт"
      className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-sky-500 text-white text-[10px] font-bold align-middle ${className}`}
    >
      ✓
    </span>
  );
};

export default OfficialBadge;
